var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('video',{staticClass:"w-full h-full",attrs:{"id":"playerBox","controls":"","autoplay":""}})}
var staticRenderFns = []

export { render, staticRenderFns }